/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as OptinImport } from './routes/optin'
import { Route as LogoutImport } from './routes/logout'
import { Route as LoginImport } from './routes/login'
import { Route as AcknowledgedImport } from './routes/acknowledged'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe/route'
import { Route as AccountRouteImport } from './routes/account/route'
import { Route as AuthRouteImport } from './routes/_auth/route'
import { Route as IndexImport } from './routes/index'
import { Route as UnsubscribeIndexImport } from './routes/unsubscribe/index'
import { Route as OptInIndexImport } from './routes/opt-in/index'
import { Route as UnsubscribeIdImport } from './routes/unsubscribe/$id'
import { Route as AccountServiceAgreementImport } from './routes/account/service-agreement'
import { Route as AccountRegisterImport } from './routes/account/register'
import { Route as AuthSettingsImport } from './routes/_auth/settings'
import { Route as OptInLayoutRouteImport } from './routes/opt-in/_layout/route'
import { Route as AccountCallbackRouteImport } from './routes/account/callback/route'
import { Route as AuthOrganizationRouteImport } from './routes/_auth/organization/route'
import { Route as AuthMessagesRouteImport } from './routes/_auth/messages/route'
import { Route as AuthDevRouteImport } from './routes/_auth/_dev/route'
import { Route as AuthProfileIndexImport } from './routes/_auth/profile/index'
import { Route as AuthOrganizationIndexImport } from './routes/_auth/organization/index'
import { Route as AuthMessagesIndexImport } from './routes/_auth/messages/index'
import { Route as AuthIpawsIndexImport } from './routes/_auth/ipaws/index'
import { Route as AuthHelpIndexImport } from './routes/_auth/help/index'
import { Route as OptInLayoutRegisterImport } from './routes/opt-in/_layout/register'
import { Route as OptInLayoutUserIdImport } from './routes/opt-in/_layout/$userId'
import { Route as AuthOrganizationUsersImport } from './routes/_auth/organization/users'
import { Route as AuthOrganizationOptInShareImport } from './routes/_auth/organization/opt-in-share'
import { Route as AuthOrganizationOptInImport } from './routes/_auth/organization/opt-in'
import { Route as AuthMessagesSentImport } from './routes/_auth/messages/sent'
import { Route as AuthMessagesScheduledImport } from './routes/_auth/messages/scheduled'
import { Route as AuthMessagesInboxImport } from './routes/_auth/messages/inbox'
import { Route as AuthMessagesComposeImport } from './routes/_auth/messages/compose'
import { Route as AuthHelpUsersImport } from './routes/_auth/help/users'
import { Route as AuthHelpTopicsImport } from './routes/_auth/help/topics'
import { Route as AuthHelpOrganizationImport } from './routes/_auth/help/organization'
import { Route as AuthHelpMessagesImport } from './routes/_auth/help/messages'
import { Route as AuthHelpIpawsImport } from './routes/_auth/help/ipaws'
import { Route as AuthOrganizationSendersRouteImport } from './routes/_auth/organization/senders/route'
import { Route as AuthOrganizationGroupsRouteImport } from './routes/_auth/organization/groups/route'
import { Route as AuthMessagesDraftsRouteImport } from './routes/_auth/messages/drafts/route'
import { Route as AuthIpawsCertificatesRouteImport } from './routes/_auth/ipaws/certificates/route'
import { Route as AuthOrganizationTopicsIndexImport } from './routes/_auth/organization/topics/index'
import { Route as AuthOrganizationSendersIndexImport } from './routes/_auth/organization/senders/index'
import { Route as AuthOrganizationGroupsIndexImport } from './routes/_auth/organization/groups/index'
import { Route as AuthOrganizationGeolocationsIndexImport } from './routes/_auth/organization/geolocations/index'
import { Route as AuthMessagesTemplatesIndexImport } from './routes/_auth/messages/templates/index'
import { Route as AuthMessagesDraftsIndexImport } from './routes/_auth/messages/drafts/index'
import { Route as AuthMessagesIdIndexImport } from './routes/_auth/messages/$id/index'
import { Route as AuthIpawsTemplatesIndexImport } from './routes/_auth/ipaws/templates/index'
import { Route as AuthIpawsDraftsIndexImport } from './routes/_auth/ipaws/drafts/index'
import { Route as AuthIpawsCertificatesIndexImport } from './routes/_auth/ipaws/certificates/index'
import { Route as AuthIpawsAlertsIndexImport } from './routes/_auth/ipaws/alerts/index'
import { Route as AuthDevDevtoolsIndexImport } from './routes/_auth/_dev/devtools/index'
import { Route as AuthOrganizationTopicsTopicIdImport } from './routes/_auth/organization/topics/$topicId'
import { Route as AuthOrganizationSendersCreateImport } from './routes/_auth/organization/senders/create'
import { Route as AuthOrganizationSendersSenderIdImport } from './routes/_auth/organization/senders/$senderId'
import { Route as AuthOrganizationGroupsCreateImport } from './routes/_auth/organization/groups/create'
import { Route as AuthOrganizationGroupsGroupIdImport } from './routes/_auth/organization/groups/$groupId'
import { Route as AuthMessagesTemplatesCreateImport } from './routes/_auth/messages/templates/create'
import { Route as AuthMessagesTemplatesIdImport } from './routes/_auth/messages/templates/$id'
import { Route as AuthMessagesDraftsIdImport } from './routes/_auth/messages/drafts/$id'
import { Route as AuthMessagesIdInsightsImport } from './routes/_auth/messages/$id/insights'
import { Route as AuthMessagesIdFwdImport } from './routes/_auth/messages/$id/fwd'
import { Route as AuthMessagesIdDetailsImport } from './routes/_auth/messages/$id/details'
import { Route as AuthIpawsUpdateAlertIdImport } from './routes/_auth/ipaws/update/$alertId'
import { Route as AuthIpawsTemplatesNewImport } from './routes/_auth/ipaws/templates/new'
import { Route as AuthIpawsTemplatesIdImport } from './routes/_auth/ipaws/templates/$id'
import { Route as AuthIpawsDraftsDraftIdImport } from './routes/_auth/ipaws/drafts/$draftId'
import { Route as AuthIpawsCertificatesCreateImport } from './routes/_auth/ipaws/certificates/create'
import { Route as AuthIpawsAlertsNewImport } from './routes/_auth/ipaws/alerts/new'
import { Route as AuthIpawsAlertsAlertIdImport } from './routes/_auth/ipaws/alerts/$alertId'
import { Route as AuthDevDevtoolsUserImportImport } from './routes/_auth/_dev/devtools/user-import'
import { Route as AuthDevDevtoolsTopicsVisImport } from './routes/_auth/_dev/devtools/topics-vis'
import { Route as AuthDevDevtoolsSystemwidePhonenumbersImport } from './routes/_auth/_dev/devtools/systemwide-phonenumbers'
import { Route as AuthDevDevtoolsRegionsImport } from './routes/_auth/_dev/devtools/regions'
import { Route as AuthDevDevtoolsMessageOMaticImport } from './routes/_auth/_dev/devtools/message-o-matic'
import { Route as AuthDevDevtoolsManageUsersImport } from './routes/_auth/_dev/devtools/manage-users'
import { Route as AuthDevDevtoolsIngestImport } from './routes/_auth/_dev/devtools/ingest'
import { Route as AuthDevDevtoolsGroupVisImport } from './routes/_auth/_dev/devtools/group-vis'
import { Route as AuthDevDevtoolsGqlImport } from './routes/_auth/_dev/devtools/gql'
import { Route as AuthDevDevtoolsDoNotSendListImport } from './routes/_auth/_dev/devtools/do-not-send-list'
import { Route as AuthDevDevtoolsBrandingImport } from './routes/_auth/_dev/devtools/branding'
import { Route as AuthIpawsCertificatesCertIdIndexImport } from './routes/_auth/ipaws/certificates/$certId/index'
import { Route as AuthDevDevtoolsRoleOMaticIndexImport } from './routes/_auth/_dev/devtools/role-o-matic/index'
import { Route as AuthDevDevtoolsCustomerIndexImport } from './routes/_auth/_dev/devtools/customer/index'
import { Route as AuthMessagesTemplatesSendIdImport } from './routes/_auth/messages/templates/send.$id'
import { Route as AuthIpawsTemplatesSendIdImport } from './routes/_auth/ipaws/templates/send.$id'
import { Route as AuthIpawsCertificatesCertIdDetailsImport } from './routes/_auth/ipaws/certificates/$certId/details'
import { Route as AuthDevDevtoolsRoleOMaticModifyImport } from './routes/_auth/_dev/devtools/role-o-matic/modify'
import { Route as AuthDevDevtoolsCustomerNumbersImport } from './routes/_auth/_dev/devtools/customer/numbers'
import { Route as AuthDevDevtoolsCustomerFeaturesImport } from './routes/_auth/_dev/devtools/customer/features'

// Create Virtual Routes

const OptInImport = createFileRoute('/opt-in')()

// Create/Update Routes

const OptInRoute = OptInImport.update({
  path: '/opt-in',
  getParentRoute: () => rootRoute,
} as any)

const OptinRoute = OptinImport.update({
  path: '/optin',
  getParentRoute: () => rootRoute,
} as any)

const LogoutRoute = LogoutImport.update({
  path: '/logout',
  getParentRoute: () => rootRoute,
} as any)

const LoginRoute = LoginImport.update({
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const AcknowledgedRoute = AcknowledgedImport.update({
  path: '/acknowledged',
  getParentRoute: () => rootRoute,
} as any)

const UnsubscribeRouteRoute = UnsubscribeRouteImport.update({
  path: '/unsubscribe',
  getParentRoute: () => rootRoute,
} as any)

const AccountRouteRoute = AccountRouteImport.update({
  path: '/account',
  getParentRoute: () => rootRoute,
} as any)

const AuthRouteRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const UnsubscribeIndexRoute = UnsubscribeIndexImport.update({
  path: '/',
  getParentRoute: () => UnsubscribeRouteRoute,
} as any)

const OptInIndexRoute = OptInIndexImport.update({
  path: '/',
  getParentRoute: () => OptInRoute,
} as any)

const UnsubscribeIdRoute = UnsubscribeIdImport.update({
  path: '/$id',
  getParentRoute: () => UnsubscribeRouteRoute,
} as any)

const AccountServiceAgreementRoute = AccountServiceAgreementImport.update({
  path: '/service-agreement',
  getParentRoute: () => AccountRouteRoute,
} as any)

const AccountRegisterRoute = AccountRegisterImport.update({
  path: '/register',
  getParentRoute: () => AccountRouteRoute,
} as any)

const AuthSettingsRoute = AuthSettingsImport.update({
  path: '/settings',
  getParentRoute: () => AuthRouteRoute,
} as any)

const OptInLayoutRouteRoute = OptInLayoutRouteImport.update({
  id: '/opt-in/_layout',
  getParentRoute: () => OptInRoute,
} as any)

const AccountCallbackRouteRoute = AccountCallbackRouteImport.update({
  path: '/callback',
  getParentRoute: () => AccountRouteRoute,
} as any)

const AuthOrganizationRouteRoute = AuthOrganizationRouteImport.update({
  path: '/organization',
  getParentRoute: () => AuthRouteRoute,
} as any)

const AuthMessagesRouteRoute = AuthMessagesRouteImport.update({
  path: '/messages',
  getParentRoute: () => AuthRouteRoute,
} as any)

const AuthDevRouteRoute = AuthDevRouteImport.update({
  id: '/_dev',
  getParentRoute: () => AuthRouteRoute,
} as any)

const AuthProfileIndexRoute = AuthProfileIndexImport.update({
  path: '/profile/',
  getParentRoute: () => AuthRouteRoute,
} as any)

const AuthOrganizationIndexRoute = AuthOrganizationIndexImport.update({
  path: '/',
  getParentRoute: () => AuthOrganizationRouteRoute,
} as any)

const AuthMessagesIndexRoute = AuthMessagesIndexImport.update({
  path: '/',
  getParentRoute: () => AuthMessagesRouteRoute,
} as any)

const AuthIpawsIndexRoute = AuthIpawsIndexImport.update({
  path: '/ipaws/',
  getParentRoute: () => AuthRouteRoute,
} as any)

const AuthHelpIndexRoute = AuthHelpIndexImport.update({
  path: '/help/',
  getParentRoute: () => AuthRouteRoute,
} as any)

const OptInLayoutRegisterRoute = OptInLayoutRegisterImport.update({
  path: '/register',
  getParentRoute: () => OptInLayoutRouteRoute,
} as any)

const OptInLayoutUserIdRoute = OptInLayoutUserIdImport.update({
  path: '/$userId',
  getParentRoute: () => OptInLayoutRouteRoute,
} as any)

const AuthOrganizationUsersRoute = AuthOrganizationUsersImport.update({
  path: '/users',
  getParentRoute: () => AuthOrganizationRouteRoute,
} as any)

const AuthOrganizationOptInShareRoute = AuthOrganizationOptInShareImport.update(
  {
    path: '/opt-in-share',
    getParentRoute: () => AuthOrganizationRouteRoute,
  } as any,
)

const AuthOrganizationOptInRoute = AuthOrganizationOptInImport.update({
  path: '/opt-in',
  getParentRoute: () => AuthOrganizationRouteRoute,
} as any)

const AuthMessagesSentRoute = AuthMessagesSentImport.update({
  path: '/sent',
  getParentRoute: () => AuthMessagesRouteRoute,
} as any)

const AuthMessagesScheduledRoute = AuthMessagesScheduledImport.update({
  path: '/scheduled',
  getParentRoute: () => AuthMessagesRouteRoute,
} as any)

const AuthMessagesInboxRoute = AuthMessagesInboxImport.update({
  path: '/inbox',
  getParentRoute: () => AuthMessagesRouteRoute,
} as any)

const AuthMessagesComposeRoute = AuthMessagesComposeImport.update({
  path: '/compose',
  getParentRoute: () => AuthMessagesRouteRoute,
} as any)

const AuthHelpUsersRoute = AuthHelpUsersImport.update({
  path: '/help/users',
  getParentRoute: () => AuthRouteRoute,
} as any)

const AuthHelpTopicsRoute = AuthHelpTopicsImport.update({
  path: '/help/topics',
  getParentRoute: () => AuthRouteRoute,
} as any)

const AuthHelpOrganizationRoute = AuthHelpOrganizationImport.update({
  path: '/help/organization',
  getParentRoute: () => AuthRouteRoute,
} as any)

const AuthHelpMessagesRoute = AuthHelpMessagesImport.update({
  path: '/help/messages',
  getParentRoute: () => AuthRouteRoute,
} as any)

const AuthHelpIpawsRoute = AuthHelpIpawsImport.update({
  path: '/help/ipaws',
  getParentRoute: () => AuthRouteRoute,
} as any)

const AuthOrganizationSendersRouteRoute =
  AuthOrganizationSendersRouteImport.update({
    path: '/senders',
    getParentRoute: () => AuthOrganizationRouteRoute,
  } as any)

const AuthOrganizationGroupsRouteRoute =
  AuthOrganizationGroupsRouteImport.update({
    path: '/groups',
    getParentRoute: () => AuthOrganizationRouteRoute,
  } as any)

const AuthMessagesDraftsRouteRoute = AuthMessagesDraftsRouteImport.update({
  path: '/drafts',
  getParentRoute: () => AuthMessagesRouteRoute,
} as any)

const AuthIpawsCertificatesRouteRoute = AuthIpawsCertificatesRouteImport.update(
  {
    path: '/ipaws/certificates',
    getParentRoute: () => AuthRouteRoute,
  } as any,
)

const AuthOrganizationTopicsIndexRoute =
  AuthOrganizationTopicsIndexImport.update({
    path: '/topics/',
    getParentRoute: () => AuthOrganizationRouteRoute,
  } as any)

const AuthOrganizationSendersIndexRoute =
  AuthOrganizationSendersIndexImport.update({
    path: '/',
    getParentRoute: () => AuthOrganizationSendersRouteRoute,
  } as any)

const AuthOrganizationGroupsIndexRoute =
  AuthOrganizationGroupsIndexImport.update({
    path: '/',
    getParentRoute: () => AuthOrganizationGroupsRouteRoute,
  } as any)

const AuthOrganizationGeolocationsIndexRoute =
  AuthOrganizationGeolocationsIndexImport.update({
    path: '/geolocations/',
    getParentRoute: () => AuthOrganizationRouteRoute,
  } as any)

const AuthMessagesTemplatesIndexRoute = AuthMessagesTemplatesIndexImport.update(
  {
    path: '/templates/',
    getParentRoute: () => AuthMessagesRouteRoute,
  } as any,
)

const AuthMessagesDraftsIndexRoute = AuthMessagesDraftsIndexImport.update({
  path: '/',
  getParentRoute: () => AuthMessagesDraftsRouteRoute,
} as any)

const AuthMessagesIdIndexRoute = AuthMessagesIdIndexImport.update({
  path: '/$id/',
  getParentRoute: () => AuthMessagesRouteRoute,
} as any)

const AuthIpawsTemplatesIndexRoute = AuthIpawsTemplatesIndexImport.update({
  path: '/ipaws/templates/',
  getParentRoute: () => AuthRouteRoute,
} as any)

const AuthIpawsDraftsIndexRoute = AuthIpawsDraftsIndexImport.update({
  path: '/ipaws/drafts/',
  getParentRoute: () => AuthRouteRoute,
} as any)

const AuthIpawsCertificatesIndexRoute = AuthIpawsCertificatesIndexImport.update(
  {
    path: '/',
    getParentRoute: () => AuthIpawsCertificatesRouteRoute,
  } as any,
)

const AuthIpawsAlertsIndexRoute = AuthIpawsAlertsIndexImport.update({
  path: '/ipaws/alerts/',
  getParentRoute: () => AuthRouteRoute,
} as any)

const AuthDevDevtoolsIndexRoute = AuthDevDevtoolsIndexImport.update({
  path: '/devtools/',
  getParentRoute: () => AuthDevRouteRoute,
} as any)

const AuthOrganizationTopicsTopicIdRoute =
  AuthOrganizationTopicsTopicIdImport.update({
    path: '/topics/$topicId',
    getParentRoute: () => AuthOrganizationRouteRoute,
  } as any)

const AuthOrganizationSendersCreateRoute =
  AuthOrganizationSendersCreateImport.update({
    path: '/create',
    getParentRoute: () => AuthOrganizationSendersRouteRoute,
  } as any)

const AuthOrganizationSendersSenderIdRoute =
  AuthOrganizationSendersSenderIdImport.update({
    path: '/$senderId',
    getParentRoute: () => AuthOrganizationSendersRouteRoute,
  } as any)

const AuthOrganizationGroupsCreateRoute =
  AuthOrganizationGroupsCreateImport.update({
    path: '/create',
    getParentRoute: () => AuthOrganizationGroupsRouteRoute,
  } as any)

const AuthOrganizationGroupsGroupIdRoute =
  AuthOrganizationGroupsGroupIdImport.update({
    path: '/$groupId',
    getParentRoute: () => AuthOrganizationGroupsRouteRoute,
  } as any)

const AuthMessagesTemplatesCreateRoute =
  AuthMessagesTemplatesCreateImport.update({
    path: '/templates/create',
    getParentRoute: () => AuthMessagesRouteRoute,
  } as any)

const AuthMessagesTemplatesIdRoute = AuthMessagesTemplatesIdImport.update({
  path: '/templates/$id',
  getParentRoute: () => AuthMessagesRouteRoute,
} as any)

const AuthMessagesDraftsIdRoute = AuthMessagesDraftsIdImport.update({
  path: '/$id',
  getParentRoute: () => AuthMessagesDraftsRouteRoute,
} as any)

const AuthMessagesIdInsightsRoute = AuthMessagesIdInsightsImport.update({
  path: '/$id/insights',
  getParentRoute: () => AuthMessagesRouteRoute,
} as any)

const AuthMessagesIdFwdRoute = AuthMessagesIdFwdImport.update({
  path: '/$id/fwd',
  getParentRoute: () => AuthMessagesRouteRoute,
} as any)

const AuthMessagesIdDetailsRoute = AuthMessagesIdDetailsImport.update({
  path: '/$id/details',
  getParentRoute: () => AuthMessagesRouteRoute,
} as any)

const AuthIpawsUpdateAlertIdRoute = AuthIpawsUpdateAlertIdImport.update({
  path: '/ipaws/update/$alertId',
  getParentRoute: () => AuthRouteRoute,
} as any)

const AuthIpawsTemplatesNewRoute = AuthIpawsTemplatesNewImport.update({
  path: '/ipaws/templates/new',
  getParentRoute: () => AuthRouteRoute,
} as any)

const AuthIpawsTemplatesIdRoute = AuthIpawsTemplatesIdImport.update({
  path: '/ipaws/templates/$id',
  getParentRoute: () => AuthRouteRoute,
} as any)

const AuthIpawsDraftsDraftIdRoute = AuthIpawsDraftsDraftIdImport.update({
  path: '/ipaws/drafts/$draftId',
  getParentRoute: () => AuthRouteRoute,
} as any)

const AuthIpawsCertificatesCreateRoute =
  AuthIpawsCertificatesCreateImport.update({
    path: '/create',
    getParentRoute: () => AuthIpawsCertificatesRouteRoute,
  } as any)

const AuthIpawsAlertsNewRoute = AuthIpawsAlertsNewImport.update({
  path: '/ipaws/alerts/new',
  getParentRoute: () => AuthRouteRoute,
} as any)

const AuthIpawsAlertsAlertIdRoute = AuthIpawsAlertsAlertIdImport.update({
  path: '/ipaws/alerts/$alertId',
  getParentRoute: () => AuthRouteRoute,
} as any)

const AuthDevDevtoolsUserImportRoute = AuthDevDevtoolsUserImportImport.update({
  path: '/devtools/user-import',
  getParentRoute: () => AuthDevRouteRoute,
} as any)

const AuthDevDevtoolsTopicsVisRoute = AuthDevDevtoolsTopicsVisImport.update({
  path: '/devtools/topics-vis',
  getParentRoute: () => AuthDevRouteRoute,
} as any)

const AuthDevDevtoolsSystemwidePhonenumbersRoute =
  AuthDevDevtoolsSystemwidePhonenumbersImport.update({
    path: '/devtools/systemwide-phonenumbers',
    getParentRoute: () => AuthDevRouteRoute,
  } as any)

const AuthDevDevtoolsRegionsRoute = AuthDevDevtoolsRegionsImport.update({
  path: '/devtools/regions',
  getParentRoute: () => AuthDevRouteRoute,
} as any)

const AuthDevDevtoolsMessageOMaticRoute =
  AuthDevDevtoolsMessageOMaticImport.update({
    path: '/devtools/message-o-matic',
    getParentRoute: () => AuthDevRouteRoute,
  } as any)

const AuthDevDevtoolsManageUsersRoute = AuthDevDevtoolsManageUsersImport.update(
  {
    path: '/devtools/manage-users',
    getParentRoute: () => AuthDevRouteRoute,
  } as any,
)

const AuthDevDevtoolsIngestRoute = AuthDevDevtoolsIngestImport.update({
  path: '/devtools/ingest',
  getParentRoute: () => AuthDevRouteRoute,
} as any)

const AuthDevDevtoolsGroupVisRoute = AuthDevDevtoolsGroupVisImport.update({
  path: '/devtools/group-vis',
  getParentRoute: () => AuthDevRouteRoute,
} as any)

const AuthDevDevtoolsGqlRoute = AuthDevDevtoolsGqlImport.update({
  path: '/devtools/gql',
  getParentRoute: () => AuthDevRouteRoute,
} as any)

const AuthDevDevtoolsDoNotSendListRoute =
  AuthDevDevtoolsDoNotSendListImport.update({
    path: '/devtools/do-not-send-list',
    getParentRoute: () => AuthDevRouteRoute,
  } as any)

const AuthDevDevtoolsBrandingRoute = AuthDevDevtoolsBrandingImport.update({
  path: '/devtools/branding',
  getParentRoute: () => AuthDevRouteRoute,
} as any)

const AuthIpawsCertificatesCertIdIndexRoute =
  AuthIpawsCertificatesCertIdIndexImport.update({
    path: '/$certId/',
    getParentRoute: () => AuthIpawsCertificatesRouteRoute,
  } as any)

const AuthDevDevtoolsRoleOMaticIndexRoute =
  AuthDevDevtoolsRoleOMaticIndexImport.update({
    path: '/devtools/role-o-matic/',
    getParentRoute: () => AuthDevRouteRoute,
  } as any)

const AuthDevDevtoolsCustomerIndexRoute =
  AuthDevDevtoolsCustomerIndexImport.update({
    path: '/devtools/customer/',
    getParentRoute: () => AuthDevRouteRoute,
  } as any)

const AuthMessagesTemplatesSendIdRoute =
  AuthMessagesTemplatesSendIdImport.update({
    path: '/templates/send/$id',
    getParentRoute: () => AuthMessagesRouteRoute,
  } as any)

const AuthIpawsTemplatesSendIdRoute = AuthIpawsTemplatesSendIdImport.update({
  path: '/ipaws/templates/send/$id',
  getParentRoute: () => AuthRouteRoute,
} as any)

const AuthIpawsCertificatesCertIdDetailsRoute =
  AuthIpawsCertificatesCertIdDetailsImport.update({
    path: '/$certId/details',
    getParentRoute: () => AuthIpawsCertificatesRouteRoute,
  } as any)

const AuthDevDevtoolsRoleOMaticModifyRoute =
  AuthDevDevtoolsRoleOMaticModifyImport.update({
    path: '/devtools/role-o-matic/modify',
    getParentRoute: () => AuthDevRouteRoute,
  } as any)

const AuthDevDevtoolsCustomerNumbersRoute =
  AuthDevDevtoolsCustomerNumbersImport.update({
    path: '/devtools/customer/numbers',
    getParentRoute: () => AuthDevRouteRoute,
  } as any)

const AuthDevDevtoolsCustomerFeaturesRoute =
  AuthDevDevtoolsCustomerFeaturesImport.update({
    path: '/devtools/customer/features',
    getParentRoute: () => AuthDevRouteRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRoute
    }
    '/account': {
      id: '/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AccountRouteImport
      parentRoute: typeof rootRoute
    }
    '/unsubscribe': {
      id: '/unsubscribe'
      path: '/unsubscribe'
      fullPath: '/unsubscribe'
      preLoaderRoute: typeof UnsubscribeRouteImport
      parentRoute: typeof rootRoute
    }
    '/acknowledged': {
      id: '/acknowledged'
      path: '/acknowledged'
      fullPath: '/acknowledged'
      preLoaderRoute: typeof AcknowledgedImport
      parentRoute: typeof rootRoute
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginImport
      parentRoute: typeof rootRoute
    }
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutImport
      parentRoute: typeof rootRoute
    }
    '/optin': {
      id: '/optin'
      path: '/optin'
      fullPath: '/optin'
      preLoaderRoute: typeof OptinImport
      parentRoute: typeof rootRoute
    }
    '/_auth/_dev': {
      id: '/_auth/_dev'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthDevRouteImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/messages': {
      id: '/_auth/messages'
      path: '/messages'
      fullPath: '/messages'
      preLoaderRoute: typeof AuthMessagesRouteImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/organization': {
      id: '/_auth/organization'
      path: '/organization'
      fullPath: '/organization'
      preLoaderRoute: typeof AuthOrganizationRouteImport
      parentRoute: typeof AuthRouteImport
    }
    '/account/callback': {
      id: '/account/callback'
      path: '/callback'
      fullPath: '/account/callback'
      preLoaderRoute: typeof AccountCallbackRouteImport
      parentRoute: typeof AccountRouteImport
    }
    '/opt-in': {
      id: '/opt-in'
      path: '/opt-in'
      fullPath: '/opt-in'
      preLoaderRoute: typeof OptInImport
      parentRoute: typeof rootRoute
    }
    '/opt-in/_layout': {
      id: '/opt-in/_layout'
      path: '/opt-in'
      fullPath: '/opt-in'
      preLoaderRoute: typeof OptInLayoutRouteImport
      parentRoute: typeof OptInRoute
    }
    '/_auth/settings': {
      id: '/_auth/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthSettingsImport
      parentRoute: typeof AuthRouteImport
    }
    '/account/register': {
      id: '/account/register'
      path: '/register'
      fullPath: '/account/register'
      preLoaderRoute: typeof AccountRegisterImport
      parentRoute: typeof AccountRouteImport
    }
    '/account/service-agreement': {
      id: '/account/service-agreement'
      path: '/service-agreement'
      fullPath: '/account/service-agreement'
      preLoaderRoute: typeof AccountServiceAgreementImport
      parentRoute: typeof AccountRouteImport
    }
    '/unsubscribe/$id': {
      id: '/unsubscribe/$id'
      path: '/$id'
      fullPath: '/unsubscribe/$id'
      preLoaderRoute: typeof UnsubscribeIdImport
      parentRoute: typeof UnsubscribeRouteImport
    }
    '/opt-in/': {
      id: '/opt-in/'
      path: '/'
      fullPath: '/opt-in/'
      preLoaderRoute: typeof OptInIndexImport
      parentRoute: typeof OptInImport
    }
    '/unsubscribe/': {
      id: '/unsubscribe/'
      path: '/'
      fullPath: '/unsubscribe/'
      preLoaderRoute: typeof UnsubscribeIndexImport
      parentRoute: typeof UnsubscribeRouteImport
    }
    '/_auth/ipaws/certificates': {
      id: '/_auth/ipaws/certificates'
      path: '/ipaws/certificates'
      fullPath: '/ipaws/certificates'
      preLoaderRoute: typeof AuthIpawsCertificatesRouteImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/messages/drafts': {
      id: '/_auth/messages/drafts'
      path: '/drafts'
      fullPath: '/messages/drafts'
      preLoaderRoute: typeof AuthMessagesDraftsRouteImport
      parentRoute: typeof AuthMessagesRouteImport
    }
    '/_auth/organization/groups': {
      id: '/_auth/organization/groups'
      path: '/groups'
      fullPath: '/organization/groups'
      preLoaderRoute: typeof AuthOrganizationGroupsRouteImport
      parentRoute: typeof AuthOrganizationRouteImport
    }
    '/_auth/organization/senders': {
      id: '/_auth/organization/senders'
      path: '/senders'
      fullPath: '/organization/senders'
      preLoaderRoute: typeof AuthOrganizationSendersRouteImport
      parentRoute: typeof AuthOrganizationRouteImport
    }
    '/_auth/help/ipaws': {
      id: '/_auth/help/ipaws'
      path: '/help/ipaws'
      fullPath: '/help/ipaws'
      preLoaderRoute: typeof AuthHelpIpawsImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/help/messages': {
      id: '/_auth/help/messages'
      path: '/help/messages'
      fullPath: '/help/messages'
      preLoaderRoute: typeof AuthHelpMessagesImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/help/organization': {
      id: '/_auth/help/organization'
      path: '/help/organization'
      fullPath: '/help/organization'
      preLoaderRoute: typeof AuthHelpOrganizationImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/help/topics': {
      id: '/_auth/help/topics'
      path: '/help/topics'
      fullPath: '/help/topics'
      preLoaderRoute: typeof AuthHelpTopicsImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/help/users': {
      id: '/_auth/help/users'
      path: '/help/users'
      fullPath: '/help/users'
      preLoaderRoute: typeof AuthHelpUsersImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/messages/compose': {
      id: '/_auth/messages/compose'
      path: '/compose'
      fullPath: '/messages/compose'
      preLoaderRoute: typeof AuthMessagesComposeImport
      parentRoute: typeof AuthMessagesRouteImport
    }
    '/_auth/messages/inbox': {
      id: '/_auth/messages/inbox'
      path: '/inbox'
      fullPath: '/messages/inbox'
      preLoaderRoute: typeof AuthMessagesInboxImport
      parentRoute: typeof AuthMessagesRouteImport
    }
    '/_auth/messages/scheduled': {
      id: '/_auth/messages/scheduled'
      path: '/scheduled'
      fullPath: '/messages/scheduled'
      preLoaderRoute: typeof AuthMessagesScheduledImport
      parentRoute: typeof AuthMessagesRouteImport
    }
    '/_auth/messages/sent': {
      id: '/_auth/messages/sent'
      path: '/sent'
      fullPath: '/messages/sent'
      preLoaderRoute: typeof AuthMessagesSentImport
      parentRoute: typeof AuthMessagesRouteImport
    }
    '/_auth/organization/opt-in': {
      id: '/_auth/organization/opt-in'
      path: '/opt-in'
      fullPath: '/organization/opt-in'
      preLoaderRoute: typeof AuthOrganizationOptInImport
      parentRoute: typeof AuthOrganizationRouteImport
    }
    '/_auth/organization/opt-in-share': {
      id: '/_auth/organization/opt-in-share'
      path: '/opt-in-share'
      fullPath: '/organization/opt-in-share'
      preLoaderRoute: typeof AuthOrganizationOptInShareImport
      parentRoute: typeof AuthOrganizationRouteImport
    }
    '/_auth/organization/users': {
      id: '/_auth/organization/users'
      path: '/users'
      fullPath: '/organization/users'
      preLoaderRoute: typeof AuthOrganizationUsersImport
      parentRoute: typeof AuthOrganizationRouteImport
    }
    '/opt-in/_layout/$userId': {
      id: '/opt-in/_layout/$userId'
      path: '/$userId'
      fullPath: '/opt-in/$userId'
      preLoaderRoute: typeof OptInLayoutUserIdImport
      parentRoute: typeof OptInLayoutRouteImport
    }
    '/opt-in/_layout/register': {
      id: '/opt-in/_layout/register'
      path: '/register'
      fullPath: '/opt-in/register'
      preLoaderRoute: typeof OptInLayoutRegisterImport
      parentRoute: typeof OptInLayoutRouteImport
    }
    '/_auth/help/': {
      id: '/_auth/help/'
      path: '/help'
      fullPath: '/help'
      preLoaderRoute: typeof AuthHelpIndexImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/ipaws/': {
      id: '/_auth/ipaws/'
      path: '/ipaws'
      fullPath: '/ipaws'
      preLoaderRoute: typeof AuthIpawsIndexImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/messages/': {
      id: '/_auth/messages/'
      path: '/'
      fullPath: '/messages/'
      preLoaderRoute: typeof AuthMessagesIndexImport
      parentRoute: typeof AuthMessagesRouteImport
    }
    '/_auth/organization/': {
      id: '/_auth/organization/'
      path: '/'
      fullPath: '/organization/'
      preLoaderRoute: typeof AuthOrganizationIndexImport
      parentRoute: typeof AuthOrganizationRouteImport
    }
    '/_auth/profile/': {
      id: '/_auth/profile/'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AuthProfileIndexImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/_dev/devtools/branding': {
      id: '/_auth/_dev/devtools/branding'
      path: '/devtools/branding'
      fullPath: '/devtools/branding'
      preLoaderRoute: typeof AuthDevDevtoolsBrandingImport
      parentRoute: typeof AuthDevRouteImport
    }
    '/_auth/_dev/devtools/do-not-send-list': {
      id: '/_auth/_dev/devtools/do-not-send-list'
      path: '/devtools/do-not-send-list'
      fullPath: '/devtools/do-not-send-list'
      preLoaderRoute: typeof AuthDevDevtoolsDoNotSendListImport
      parentRoute: typeof AuthDevRouteImport
    }
    '/_auth/_dev/devtools/gql': {
      id: '/_auth/_dev/devtools/gql'
      path: '/devtools/gql'
      fullPath: '/devtools/gql'
      preLoaderRoute: typeof AuthDevDevtoolsGqlImport
      parentRoute: typeof AuthDevRouteImport
    }
    '/_auth/_dev/devtools/group-vis': {
      id: '/_auth/_dev/devtools/group-vis'
      path: '/devtools/group-vis'
      fullPath: '/devtools/group-vis'
      preLoaderRoute: typeof AuthDevDevtoolsGroupVisImport
      parentRoute: typeof AuthDevRouteImport
    }
    '/_auth/_dev/devtools/ingest': {
      id: '/_auth/_dev/devtools/ingest'
      path: '/devtools/ingest'
      fullPath: '/devtools/ingest'
      preLoaderRoute: typeof AuthDevDevtoolsIngestImport
      parentRoute: typeof AuthDevRouteImport
    }
    '/_auth/_dev/devtools/manage-users': {
      id: '/_auth/_dev/devtools/manage-users'
      path: '/devtools/manage-users'
      fullPath: '/devtools/manage-users'
      preLoaderRoute: typeof AuthDevDevtoolsManageUsersImport
      parentRoute: typeof AuthDevRouteImport
    }
    '/_auth/_dev/devtools/message-o-matic': {
      id: '/_auth/_dev/devtools/message-o-matic'
      path: '/devtools/message-o-matic'
      fullPath: '/devtools/message-o-matic'
      preLoaderRoute: typeof AuthDevDevtoolsMessageOMaticImport
      parentRoute: typeof AuthDevRouteImport
    }
    '/_auth/_dev/devtools/regions': {
      id: '/_auth/_dev/devtools/regions'
      path: '/devtools/regions'
      fullPath: '/devtools/regions'
      preLoaderRoute: typeof AuthDevDevtoolsRegionsImport
      parentRoute: typeof AuthDevRouteImport
    }
    '/_auth/_dev/devtools/systemwide-phonenumbers': {
      id: '/_auth/_dev/devtools/systemwide-phonenumbers'
      path: '/devtools/systemwide-phonenumbers'
      fullPath: '/devtools/systemwide-phonenumbers'
      preLoaderRoute: typeof AuthDevDevtoolsSystemwidePhonenumbersImport
      parentRoute: typeof AuthDevRouteImport
    }
    '/_auth/_dev/devtools/topics-vis': {
      id: '/_auth/_dev/devtools/topics-vis'
      path: '/devtools/topics-vis'
      fullPath: '/devtools/topics-vis'
      preLoaderRoute: typeof AuthDevDevtoolsTopicsVisImport
      parentRoute: typeof AuthDevRouteImport
    }
    '/_auth/_dev/devtools/user-import': {
      id: '/_auth/_dev/devtools/user-import'
      path: '/devtools/user-import'
      fullPath: '/devtools/user-import'
      preLoaderRoute: typeof AuthDevDevtoolsUserImportImport
      parentRoute: typeof AuthDevRouteImport
    }
    '/_auth/ipaws/alerts/$alertId': {
      id: '/_auth/ipaws/alerts/$alertId'
      path: '/ipaws/alerts/$alertId'
      fullPath: '/ipaws/alerts/$alertId'
      preLoaderRoute: typeof AuthIpawsAlertsAlertIdImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/ipaws/alerts/new': {
      id: '/_auth/ipaws/alerts/new'
      path: '/ipaws/alerts/new'
      fullPath: '/ipaws/alerts/new'
      preLoaderRoute: typeof AuthIpawsAlertsNewImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/ipaws/certificates/create': {
      id: '/_auth/ipaws/certificates/create'
      path: '/create'
      fullPath: '/ipaws/certificates/create'
      preLoaderRoute: typeof AuthIpawsCertificatesCreateImport
      parentRoute: typeof AuthIpawsCertificatesRouteImport
    }
    '/_auth/ipaws/drafts/$draftId': {
      id: '/_auth/ipaws/drafts/$draftId'
      path: '/ipaws/drafts/$draftId'
      fullPath: '/ipaws/drafts/$draftId'
      preLoaderRoute: typeof AuthIpawsDraftsDraftIdImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/ipaws/templates/$id': {
      id: '/_auth/ipaws/templates/$id'
      path: '/ipaws/templates/$id'
      fullPath: '/ipaws/templates/$id'
      preLoaderRoute: typeof AuthIpawsTemplatesIdImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/ipaws/templates/new': {
      id: '/_auth/ipaws/templates/new'
      path: '/ipaws/templates/new'
      fullPath: '/ipaws/templates/new'
      preLoaderRoute: typeof AuthIpawsTemplatesNewImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/ipaws/update/$alertId': {
      id: '/_auth/ipaws/update/$alertId'
      path: '/ipaws/update/$alertId'
      fullPath: '/ipaws/update/$alertId'
      preLoaderRoute: typeof AuthIpawsUpdateAlertIdImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/messages/$id/details': {
      id: '/_auth/messages/$id/details'
      path: '/$id/details'
      fullPath: '/messages/$id/details'
      preLoaderRoute: typeof AuthMessagesIdDetailsImport
      parentRoute: typeof AuthMessagesRouteImport
    }
    '/_auth/messages/$id/fwd': {
      id: '/_auth/messages/$id/fwd'
      path: '/$id/fwd'
      fullPath: '/messages/$id/fwd'
      preLoaderRoute: typeof AuthMessagesIdFwdImport
      parentRoute: typeof AuthMessagesRouteImport
    }
    '/_auth/messages/$id/insights': {
      id: '/_auth/messages/$id/insights'
      path: '/$id/insights'
      fullPath: '/messages/$id/insights'
      preLoaderRoute: typeof AuthMessagesIdInsightsImport
      parentRoute: typeof AuthMessagesRouteImport
    }
    '/_auth/messages/drafts/$id': {
      id: '/_auth/messages/drafts/$id'
      path: '/$id'
      fullPath: '/messages/drafts/$id'
      preLoaderRoute: typeof AuthMessagesDraftsIdImport
      parentRoute: typeof AuthMessagesDraftsRouteImport
    }
    '/_auth/messages/templates/$id': {
      id: '/_auth/messages/templates/$id'
      path: '/templates/$id'
      fullPath: '/messages/templates/$id'
      preLoaderRoute: typeof AuthMessagesTemplatesIdImport
      parentRoute: typeof AuthMessagesRouteImport
    }
    '/_auth/messages/templates/create': {
      id: '/_auth/messages/templates/create'
      path: '/templates/create'
      fullPath: '/messages/templates/create'
      preLoaderRoute: typeof AuthMessagesTemplatesCreateImport
      parentRoute: typeof AuthMessagesRouteImport
    }
    '/_auth/organization/groups/$groupId': {
      id: '/_auth/organization/groups/$groupId'
      path: '/$groupId'
      fullPath: '/organization/groups/$groupId'
      preLoaderRoute: typeof AuthOrganizationGroupsGroupIdImport
      parentRoute: typeof AuthOrganizationGroupsRouteImport
    }
    '/_auth/organization/groups/create': {
      id: '/_auth/organization/groups/create'
      path: '/create'
      fullPath: '/organization/groups/create'
      preLoaderRoute: typeof AuthOrganizationGroupsCreateImport
      parentRoute: typeof AuthOrganizationGroupsRouteImport
    }
    '/_auth/organization/senders/$senderId': {
      id: '/_auth/organization/senders/$senderId'
      path: '/$senderId'
      fullPath: '/organization/senders/$senderId'
      preLoaderRoute: typeof AuthOrganizationSendersSenderIdImport
      parentRoute: typeof AuthOrganizationSendersRouteImport
    }
    '/_auth/organization/senders/create': {
      id: '/_auth/organization/senders/create'
      path: '/create'
      fullPath: '/organization/senders/create'
      preLoaderRoute: typeof AuthOrganizationSendersCreateImport
      parentRoute: typeof AuthOrganizationSendersRouteImport
    }
    '/_auth/organization/topics/$topicId': {
      id: '/_auth/organization/topics/$topicId'
      path: '/topics/$topicId'
      fullPath: '/organization/topics/$topicId'
      preLoaderRoute: typeof AuthOrganizationTopicsTopicIdImport
      parentRoute: typeof AuthOrganizationRouteImport
    }
    '/_auth/_dev/devtools/': {
      id: '/_auth/_dev/devtools/'
      path: '/devtools'
      fullPath: '/devtools'
      preLoaderRoute: typeof AuthDevDevtoolsIndexImport
      parentRoute: typeof AuthDevRouteImport
    }
    '/_auth/ipaws/alerts/': {
      id: '/_auth/ipaws/alerts/'
      path: '/ipaws/alerts'
      fullPath: '/ipaws/alerts'
      preLoaderRoute: typeof AuthIpawsAlertsIndexImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/ipaws/certificates/': {
      id: '/_auth/ipaws/certificates/'
      path: '/'
      fullPath: '/ipaws/certificates/'
      preLoaderRoute: typeof AuthIpawsCertificatesIndexImport
      parentRoute: typeof AuthIpawsCertificatesRouteImport
    }
    '/_auth/ipaws/drafts/': {
      id: '/_auth/ipaws/drafts/'
      path: '/ipaws/drafts'
      fullPath: '/ipaws/drafts'
      preLoaderRoute: typeof AuthIpawsDraftsIndexImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/ipaws/templates/': {
      id: '/_auth/ipaws/templates/'
      path: '/ipaws/templates'
      fullPath: '/ipaws/templates'
      preLoaderRoute: typeof AuthIpawsTemplatesIndexImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/messages/$id/': {
      id: '/_auth/messages/$id/'
      path: '/$id'
      fullPath: '/messages/$id'
      preLoaderRoute: typeof AuthMessagesIdIndexImport
      parentRoute: typeof AuthMessagesRouteImport
    }
    '/_auth/messages/drafts/': {
      id: '/_auth/messages/drafts/'
      path: '/'
      fullPath: '/messages/drafts/'
      preLoaderRoute: typeof AuthMessagesDraftsIndexImport
      parentRoute: typeof AuthMessagesDraftsRouteImport
    }
    '/_auth/messages/templates/': {
      id: '/_auth/messages/templates/'
      path: '/templates'
      fullPath: '/messages/templates'
      preLoaderRoute: typeof AuthMessagesTemplatesIndexImport
      parentRoute: typeof AuthMessagesRouteImport
    }
    '/_auth/organization/geolocations/': {
      id: '/_auth/organization/geolocations/'
      path: '/geolocations'
      fullPath: '/organization/geolocations'
      preLoaderRoute: typeof AuthOrganizationGeolocationsIndexImport
      parentRoute: typeof AuthOrganizationRouteImport
    }
    '/_auth/organization/groups/': {
      id: '/_auth/organization/groups/'
      path: '/'
      fullPath: '/organization/groups/'
      preLoaderRoute: typeof AuthOrganizationGroupsIndexImport
      parentRoute: typeof AuthOrganizationGroupsRouteImport
    }
    '/_auth/organization/senders/': {
      id: '/_auth/organization/senders/'
      path: '/'
      fullPath: '/organization/senders/'
      preLoaderRoute: typeof AuthOrganizationSendersIndexImport
      parentRoute: typeof AuthOrganizationSendersRouteImport
    }
    '/_auth/organization/topics/': {
      id: '/_auth/organization/topics/'
      path: '/topics'
      fullPath: '/organization/topics'
      preLoaderRoute: typeof AuthOrganizationTopicsIndexImport
      parentRoute: typeof AuthOrganizationRouteImport
    }
    '/_auth/_dev/devtools/customer/features': {
      id: '/_auth/_dev/devtools/customer/features'
      path: '/devtools/customer/features'
      fullPath: '/devtools/customer/features'
      preLoaderRoute: typeof AuthDevDevtoolsCustomerFeaturesImport
      parentRoute: typeof AuthDevRouteImport
    }
    '/_auth/_dev/devtools/customer/numbers': {
      id: '/_auth/_dev/devtools/customer/numbers'
      path: '/devtools/customer/numbers'
      fullPath: '/devtools/customer/numbers'
      preLoaderRoute: typeof AuthDevDevtoolsCustomerNumbersImport
      parentRoute: typeof AuthDevRouteImport
    }
    '/_auth/_dev/devtools/role-o-matic/modify': {
      id: '/_auth/_dev/devtools/role-o-matic/modify'
      path: '/devtools/role-o-matic/modify'
      fullPath: '/devtools/role-o-matic/modify'
      preLoaderRoute: typeof AuthDevDevtoolsRoleOMaticModifyImport
      parentRoute: typeof AuthDevRouteImport
    }
    '/_auth/ipaws/certificates/$certId/details': {
      id: '/_auth/ipaws/certificates/$certId/details'
      path: '/$certId/details'
      fullPath: '/ipaws/certificates/$certId/details'
      preLoaderRoute: typeof AuthIpawsCertificatesCertIdDetailsImport
      parentRoute: typeof AuthIpawsCertificatesRouteImport
    }
    '/_auth/ipaws/templates/send/$id': {
      id: '/_auth/ipaws/templates/send/$id'
      path: '/ipaws/templates/send/$id'
      fullPath: '/ipaws/templates/send/$id'
      preLoaderRoute: typeof AuthIpawsTemplatesSendIdImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/messages/templates/send/$id': {
      id: '/_auth/messages/templates/send/$id'
      path: '/templates/send/$id'
      fullPath: '/messages/templates/send/$id'
      preLoaderRoute: typeof AuthMessagesTemplatesSendIdImport
      parentRoute: typeof AuthMessagesRouteImport
    }
    '/_auth/_dev/devtools/customer/': {
      id: '/_auth/_dev/devtools/customer/'
      path: '/devtools/customer'
      fullPath: '/devtools/customer'
      preLoaderRoute: typeof AuthDevDevtoolsCustomerIndexImport
      parentRoute: typeof AuthDevRouteImport
    }
    '/_auth/_dev/devtools/role-o-matic/': {
      id: '/_auth/_dev/devtools/role-o-matic/'
      path: '/devtools/role-o-matic'
      fullPath: '/devtools/role-o-matic'
      preLoaderRoute: typeof AuthDevDevtoolsRoleOMaticIndexImport
      parentRoute: typeof AuthDevRouteImport
    }
    '/_auth/ipaws/certificates/$certId/': {
      id: '/_auth/ipaws/certificates/$certId/'
      path: '/$certId'
      fullPath: '/ipaws/certificates/$certId'
      preLoaderRoute: typeof AuthIpawsCertificatesCertIdIndexImport
      parentRoute: typeof AuthIpawsCertificatesRouteImport
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren({
  IndexRoute,
  AuthRouteRoute: AuthRouteRoute.addChildren({
    AuthDevRouteRoute: AuthDevRouteRoute.addChildren({
      AuthDevDevtoolsBrandingRoute,
      AuthDevDevtoolsDoNotSendListRoute,
      AuthDevDevtoolsGqlRoute,
      AuthDevDevtoolsGroupVisRoute,
      AuthDevDevtoolsIngestRoute,
      AuthDevDevtoolsManageUsersRoute,
      AuthDevDevtoolsMessageOMaticRoute,
      AuthDevDevtoolsRegionsRoute,
      AuthDevDevtoolsSystemwidePhonenumbersRoute,
      AuthDevDevtoolsTopicsVisRoute,
      AuthDevDevtoolsUserImportRoute,
      AuthDevDevtoolsIndexRoute,
      AuthDevDevtoolsCustomerFeaturesRoute,
      AuthDevDevtoolsCustomerNumbersRoute,
      AuthDevDevtoolsRoleOMaticModifyRoute,
      AuthDevDevtoolsCustomerIndexRoute,
      AuthDevDevtoolsRoleOMaticIndexRoute,
    }),
    AuthMessagesRouteRoute: AuthMessagesRouteRoute.addChildren({
      AuthMessagesDraftsRouteRoute: AuthMessagesDraftsRouteRoute.addChildren({
        AuthMessagesDraftsIdRoute,
        AuthMessagesDraftsIndexRoute,
      }),
      AuthMessagesComposeRoute,
      AuthMessagesInboxRoute,
      AuthMessagesScheduledRoute,
      AuthMessagesSentRoute,
      AuthMessagesIndexRoute,
      AuthMessagesIdDetailsRoute,
      AuthMessagesIdFwdRoute,
      AuthMessagesIdInsightsRoute,
      AuthMessagesTemplatesIdRoute,
      AuthMessagesTemplatesCreateRoute,
      AuthMessagesIdIndexRoute,
      AuthMessagesTemplatesIndexRoute,
      AuthMessagesTemplatesSendIdRoute,
    }),
    AuthOrganizationRouteRoute: AuthOrganizationRouteRoute.addChildren({
      AuthOrganizationGroupsRouteRoute:
        AuthOrganizationGroupsRouteRoute.addChildren({
          AuthOrganizationGroupsGroupIdRoute,
          AuthOrganizationGroupsCreateRoute,
          AuthOrganizationGroupsIndexRoute,
        }),
      AuthOrganizationSendersRouteRoute:
        AuthOrganizationSendersRouteRoute.addChildren({
          AuthOrganizationSendersSenderIdRoute,
          AuthOrganizationSendersCreateRoute,
          AuthOrganizationSendersIndexRoute,
        }),
      AuthOrganizationOptInRoute,
      AuthOrganizationOptInShareRoute,
      AuthOrganizationUsersRoute,
      AuthOrganizationIndexRoute,
      AuthOrganizationTopicsTopicIdRoute,
      AuthOrganizationGeolocationsIndexRoute,
      AuthOrganizationTopicsIndexRoute,
    }),
    AuthSettingsRoute,
    AuthIpawsCertificatesRouteRoute:
      AuthIpawsCertificatesRouteRoute.addChildren({
        AuthIpawsCertificatesCreateRoute,
        AuthIpawsCertificatesIndexRoute,
        AuthIpawsCertificatesCertIdDetailsRoute,
        AuthIpawsCertificatesCertIdIndexRoute,
      }),
    AuthHelpIpawsRoute,
    AuthHelpMessagesRoute,
    AuthHelpOrganizationRoute,
    AuthHelpTopicsRoute,
    AuthHelpUsersRoute,
    AuthHelpIndexRoute,
    AuthIpawsIndexRoute,
    AuthProfileIndexRoute,
    AuthIpawsAlertsAlertIdRoute,
    AuthIpawsAlertsNewRoute,
    AuthIpawsDraftsDraftIdRoute,
    AuthIpawsTemplatesIdRoute,
    AuthIpawsTemplatesNewRoute,
    AuthIpawsUpdateAlertIdRoute,
    AuthIpawsAlertsIndexRoute,
    AuthIpawsDraftsIndexRoute,
    AuthIpawsTemplatesIndexRoute,
    AuthIpawsTemplatesSendIdRoute,
  }),
  AccountRouteRoute: AccountRouteRoute.addChildren({
    AccountCallbackRouteRoute,
    AccountRegisterRoute,
    AccountServiceAgreementRoute,
  }),
  UnsubscribeRouteRoute: UnsubscribeRouteRoute.addChildren({
    UnsubscribeIdRoute,
    UnsubscribeIndexRoute,
  }),
  AcknowledgedRoute,
  LoginRoute,
  LogoutRoute,
  OptinRoute,
  OptInRoute: OptInRoute.addChildren({
    OptInLayoutRouteRoute: OptInLayoutRouteRoute.addChildren({
      OptInLayoutUserIdRoute,
      OptInLayoutRegisterRoute,
    }),
    OptInIndexRoute,
  }),
})

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_auth",
        "/account",
        "/unsubscribe",
        "/acknowledged",
        "/login",
        "/logout",
        "/optin",
        "/opt-in"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/_auth": {
      "filePath": "_auth/route.tsx",
      "children": [
        "/_auth/_dev",
        "/_auth/messages",
        "/_auth/organization",
        "/_auth/settings",
        "/_auth/ipaws/certificates",
        "/_auth/help/ipaws",
        "/_auth/help/messages",
        "/_auth/help/organization",
        "/_auth/help/topics",
        "/_auth/help/users",
        "/_auth/help/",
        "/_auth/ipaws/",
        "/_auth/profile/",
        "/_auth/ipaws/alerts/$alertId",
        "/_auth/ipaws/alerts/new",
        "/_auth/ipaws/drafts/$draftId",
        "/_auth/ipaws/templates/$id",
        "/_auth/ipaws/templates/new",
        "/_auth/ipaws/update/$alertId",
        "/_auth/ipaws/alerts/",
        "/_auth/ipaws/drafts/",
        "/_auth/ipaws/templates/",
        "/_auth/ipaws/templates/send/$id"
      ]
    },
    "/account": {
      "filePath": "account/route.tsx",
      "children": [
        "/account/callback",
        "/account/register",
        "/account/service-agreement"
      ]
    },
    "/unsubscribe": {
      "filePath": "unsubscribe/route.tsx",
      "children": [
        "/unsubscribe/$id",
        "/unsubscribe/"
      ]
    },
    "/acknowledged": {
      "filePath": "acknowledged.tsx"
    },
    "/login": {
      "filePath": "login.tsx"
    },
    "/logout": {
      "filePath": "logout.tsx"
    },
    "/optin": {
      "filePath": "optin.tsx"
    },
    "/_auth/_dev": {
      "filePath": "_auth/_dev/route.tsx",
      "parent": "/_auth",
      "children": [
        "/_auth/_dev/devtools/branding",
        "/_auth/_dev/devtools/do-not-send-list",
        "/_auth/_dev/devtools/gql",
        "/_auth/_dev/devtools/group-vis",
        "/_auth/_dev/devtools/ingest",
        "/_auth/_dev/devtools/manage-users",
        "/_auth/_dev/devtools/message-o-matic",
        "/_auth/_dev/devtools/regions",
        "/_auth/_dev/devtools/systemwide-phonenumbers",
        "/_auth/_dev/devtools/topics-vis",
        "/_auth/_dev/devtools/user-import",
        "/_auth/_dev/devtools/",
        "/_auth/_dev/devtools/customer/features",
        "/_auth/_dev/devtools/customer/numbers",
        "/_auth/_dev/devtools/role-o-matic/modify",
        "/_auth/_dev/devtools/customer/",
        "/_auth/_dev/devtools/role-o-matic/"
      ]
    },
    "/_auth/messages": {
      "filePath": "_auth/messages/route.tsx",
      "parent": "/_auth",
      "children": [
        "/_auth/messages/drafts",
        "/_auth/messages/compose",
        "/_auth/messages/inbox",
        "/_auth/messages/scheduled",
        "/_auth/messages/sent",
        "/_auth/messages/",
        "/_auth/messages/$id/details",
        "/_auth/messages/$id/fwd",
        "/_auth/messages/$id/insights",
        "/_auth/messages/templates/$id",
        "/_auth/messages/templates/create",
        "/_auth/messages/$id/",
        "/_auth/messages/templates/",
        "/_auth/messages/templates/send/$id"
      ]
    },
    "/_auth/organization": {
      "filePath": "_auth/organization/route.tsx",
      "parent": "/_auth",
      "children": [
        "/_auth/organization/groups",
        "/_auth/organization/senders",
        "/_auth/organization/opt-in",
        "/_auth/organization/opt-in-share",
        "/_auth/organization/users",
        "/_auth/organization/",
        "/_auth/organization/topics/$topicId",
        "/_auth/organization/geolocations/",
        "/_auth/organization/topics/"
      ]
    },
    "/account/callback": {
      "filePath": "account/callback/route.tsx",
      "parent": "/account"
    },
    "/opt-in": {
      "filePath": "opt-in/_layout",
      "children": [
        "/opt-in/_layout",
        "/opt-in/"
      ]
    },
    "/opt-in/_layout": {
      "filePath": "opt-in/_layout/route.tsx",
      "parent": "/opt-in",
      "children": [
        "/opt-in/_layout/$userId",
        "/opt-in/_layout/register"
      ]
    },
    "/_auth/settings": {
      "filePath": "_auth/settings.tsx",
      "parent": "/_auth"
    },
    "/account/register": {
      "filePath": "account/register.tsx",
      "parent": "/account"
    },
    "/account/service-agreement": {
      "filePath": "account/service-agreement.tsx",
      "parent": "/account"
    },
    "/unsubscribe/$id": {
      "filePath": "unsubscribe/$id.tsx",
      "parent": "/unsubscribe"
    },
    "/opt-in/": {
      "filePath": "opt-in/index.tsx",
      "parent": "/opt-in"
    },
    "/unsubscribe/": {
      "filePath": "unsubscribe/index.tsx",
      "parent": "/unsubscribe"
    },
    "/_auth/ipaws/certificates": {
      "filePath": "_auth/ipaws/certificates/route.tsx",
      "parent": "/_auth",
      "children": [
        "/_auth/ipaws/certificates/create",
        "/_auth/ipaws/certificates/",
        "/_auth/ipaws/certificates/$certId/details",
        "/_auth/ipaws/certificates/$certId/"
      ]
    },
    "/_auth/messages/drafts": {
      "filePath": "_auth/messages/drafts/route.tsx",
      "parent": "/_auth/messages",
      "children": [
        "/_auth/messages/drafts/$id",
        "/_auth/messages/drafts/"
      ]
    },
    "/_auth/organization/groups": {
      "filePath": "_auth/organization/groups/route.tsx",
      "parent": "/_auth/organization",
      "children": [
        "/_auth/organization/groups/$groupId",
        "/_auth/organization/groups/create",
        "/_auth/organization/groups/"
      ]
    },
    "/_auth/organization/senders": {
      "filePath": "_auth/organization/senders/route.tsx",
      "parent": "/_auth/organization",
      "children": [
        "/_auth/organization/senders/$senderId",
        "/_auth/organization/senders/create",
        "/_auth/organization/senders/"
      ]
    },
    "/_auth/help/ipaws": {
      "filePath": "_auth/help/ipaws.tsx",
      "parent": "/_auth"
    },
    "/_auth/help/messages": {
      "filePath": "_auth/help/messages.tsx",
      "parent": "/_auth"
    },
    "/_auth/help/organization": {
      "filePath": "_auth/help/organization.tsx",
      "parent": "/_auth"
    },
    "/_auth/help/topics": {
      "filePath": "_auth/help/topics.tsx",
      "parent": "/_auth"
    },
    "/_auth/help/users": {
      "filePath": "_auth/help/users.tsx",
      "parent": "/_auth"
    },
    "/_auth/messages/compose": {
      "filePath": "_auth/messages/compose.tsx",
      "parent": "/_auth/messages"
    },
    "/_auth/messages/inbox": {
      "filePath": "_auth/messages/inbox.tsx",
      "parent": "/_auth/messages"
    },
    "/_auth/messages/scheduled": {
      "filePath": "_auth/messages/scheduled.tsx",
      "parent": "/_auth/messages"
    },
    "/_auth/messages/sent": {
      "filePath": "_auth/messages/sent.tsx",
      "parent": "/_auth/messages"
    },
    "/_auth/organization/opt-in": {
      "filePath": "_auth/organization/opt-in.tsx",
      "parent": "/_auth/organization"
    },
    "/_auth/organization/opt-in-share": {
      "filePath": "_auth/organization/opt-in-share.tsx",
      "parent": "/_auth/organization"
    },
    "/_auth/organization/users": {
      "filePath": "_auth/organization/users.tsx",
      "parent": "/_auth/organization"
    },
    "/opt-in/_layout/$userId": {
      "filePath": "opt-in/_layout/$userId.tsx",
      "parent": "/opt-in/_layout"
    },
    "/opt-in/_layout/register": {
      "filePath": "opt-in/_layout/register.tsx",
      "parent": "/opt-in/_layout"
    },
    "/_auth/help/": {
      "filePath": "_auth/help/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/ipaws/": {
      "filePath": "_auth/ipaws/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/messages/": {
      "filePath": "_auth/messages/index.tsx",
      "parent": "/_auth/messages"
    },
    "/_auth/organization/": {
      "filePath": "_auth/organization/index.tsx",
      "parent": "/_auth/organization"
    },
    "/_auth/profile/": {
      "filePath": "_auth/profile/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/_dev/devtools/branding": {
      "filePath": "_auth/_dev/devtools/branding.tsx",
      "parent": "/_auth/_dev"
    },
    "/_auth/_dev/devtools/do-not-send-list": {
      "filePath": "_auth/_dev/devtools/do-not-send-list.tsx",
      "parent": "/_auth/_dev"
    },
    "/_auth/_dev/devtools/gql": {
      "filePath": "_auth/_dev/devtools/gql.tsx",
      "parent": "/_auth/_dev"
    },
    "/_auth/_dev/devtools/group-vis": {
      "filePath": "_auth/_dev/devtools/group-vis.tsx",
      "parent": "/_auth/_dev"
    },
    "/_auth/_dev/devtools/ingest": {
      "filePath": "_auth/_dev/devtools/ingest.tsx",
      "parent": "/_auth/_dev"
    },
    "/_auth/_dev/devtools/manage-users": {
      "filePath": "_auth/_dev/devtools/manage-users.tsx",
      "parent": "/_auth/_dev"
    },
    "/_auth/_dev/devtools/message-o-matic": {
      "filePath": "_auth/_dev/devtools/message-o-matic.tsx",
      "parent": "/_auth/_dev"
    },
    "/_auth/_dev/devtools/regions": {
      "filePath": "_auth/_dev/devtools/regions.tsx",
      "parent": "/_auth/_dev"
    },
    "/_auth/_dev/devtools/systemwide-phonenumbers": {
      "filePath": "_auth/_dev/devtools/systemwide-phonenumbers.tsx",
      "parent": "/_auth/_dev"
    },
    "/_auth/_dev/devtools/topics-vis": {
      "filePath": "_auth/_dev/devtools/topics-vis.tsx",
      "parent": "/_auth/_dev"
    },
    "/_auth/_dev/devtools/user-import": {
      "filePath": "_auth/_dev/devtools/user-import.tsx",
      "parent": "/_auth/_dev"
    },
    "/_auth/ipaws/alerts/$alertId": {
      "filePath": "_auth/ipaws/alerts/$alertId.tsx",
      "parent": "/_auth"
    },
    "/_auth/ipaws/alerts/new": {
      "filePath": "_auth/ipaws/alerts/new.tsx",
      "parent": "/_auth"
    },
    "/_auth/ipaws/certificates/create": {
      "filePath": "_auth/ipaws/certificates/create.tsx",
      "parent": "/_auth/ipaws/certificates"
    },
    "/_auth/ipaws/drafts/$draftId": {
      "filePath": "_auth/ipaws/drafts/$draftId.tsx",
      "parent": "/_auth"
    },
    "/_auth/ipaws/templates/$id": {
      "filePath": "_auth/ipaws/templates/$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/ipaws/templates/new": {
      "filePath": "_auth/ipaws/templates/new.tsx",
      "parent": "/_auth"
    },
    "/_auth/ipaws/update/$alertId": {
      "filePath": "_auth/ipaws/update/$alertId.tsx",
      "parent": "/_auth"
    },
    "/_auth/messages/$id/details": {
      "filePath": "_auth/messages/$id/details.tsx",
      "parent": "/_auth/messages"
    },
    "/_auth/messages/$id/fwd": {
      "filePath": "_auth/messages/$id/fwd.tsx",
      "parent": "/_auth/messages"
    },
    "/_auth/messages/$id/insights": {
      "filePath": "_auth/messages/$id/insights.tsx",
      "parent": "/_auth/messages"
    },
    "/_auth/messages/drafts/$id": {
      "filePath": "_auth/messages/drafts/$id.tsx",
      "parent": "/_auth/messages/drafts"
    },
    "/_auth/messages/templates/$id": {
      "filePath": "_auth/messages/templates/$id.tsx",
      "parent": "/_auth/messages"
    },
    "/_auth/messages/templates/create": {
      "filePath": "_auth/messages/templates/create.tsx",
      "parent": "/_auth/messages"
    },
    "/_auth/organization/groups/$groupId": {
      "filePath": "_auth/organization/groups/$groupId.tsx",
      "parent": "/_auth/organization/groups"
    },
    "/_auth/organization/groups/create": {
      "filePath": "_auth/organization/groups/create.tsx",
      "parent": "/_auth/organization/groups"
    },
    "/_auth/organization/senders/$senderId": {
      "filePath": "_auth/organization/senders/$senderId.tsx",
      "parent": "/_auth/organization/senders"
    },
    "/_auth/organization/senders/create": {
      "filePath": "_auth/organization/senders/create.tsx",
      "parent": "/_auth/organization/senders"
    },
    "/_auth/organization/topics/$topicId": {
      "filePath": "_auth/organization/topics/$topicId.tsx",
      "parent": "/_auth/organization"
    },
    "/_auth/_dev/devtools/": {
      "filePath": "_auth/_dev/devtools/index.tsx",
      "parent": "/_auth/_dev"
    },
    "/_auth/ipaws/alerts/": {
      "filePath": "_auth/ipaws/alerts/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/ipaws/certificates/": {
      "filePath": "_auth/ipaws/certificates/index.tsx",
      "parent": "/_auth/ipaws/certificates"
    },
    "/_auth/ipaws/drafts/": {
      "filePath": "_auth/ipaws/drafts/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/ipaws/templates/": {
      "filePath": "_auth/ipaws/templates/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/messages/$id/": {
      "filePath": "_auth/messages/$id/index.tsx",
      "parent": "/_auth/messages"
    },
    "/_auth/messages/drafts/": {
      "filePath": "_auth/messages/drafts/index.tsx",
      "parent": "/_auth/messages/drafts"
    },
    "/_auth/messages/templates/": {
      "filePath": "_auth/messages/templates/index.tsx",
      "parent": "/_auth/messages"
    },
    "/_auth/organization/geolocations/": {
      "filePath": "_auth/organization/geolocations/index.tsx",
      "parent": "/_auth/organization"
    },
    "/_auth/organization/groups/": {
      "filePath": "_auth/organization/groups/index.tsx",
      "parent": "/_auth/organization/groups"
    },
    "/_auth/organization/senders/": {
      "filePath": "_auth/organization/senders/index.tsx",
      "parent": "/_auth/organization/senders"
    },
    "/_auth/organization/topics/": {
      "filePath": "_auth/organization/topics/index.tsx",
      "parent": "/_auth/organization"
    },
    "/_auth/_dev/devtools/customer/features": {
      "filePath": "_auth/_dev/devtools/customer/features.tsx",
      "parent": "/_auth/_dev"
    },
    "/_auth/_dev/devtools/customer/numbers": {
      "filePath": "_auth/_dev/devtools/customer/numbers.tsx",
      "parent": "/_auth/_dev"
    },
    "/_auth/_dev/devtools/role-o-matic/modify": {
      "filePath": "_auth/_dev/devtools/role-o-matic/modify.tsx",
      "parent": "/_auth/_dev"
    },
    "/_auth/ipaws/certificates/$certId/details": {
      "filePath": "_auth/ipaws/certificates/$certId/details.tsx",
      "parent": "/_auth/ipaws/certificates"
    },
    "/_auth/ipaws/templates/send/$id": {
      "filePath": "_auth/ipaws/templates/send.$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/messages/templates/send/$id": {
      "filePath": "_auth/messages/templates/send.$id.tsx",
      "parent": "/_auth/messages"
    },
    "/_auth/_dev/devtools/customer/": {
      "filePath": "_auth/_dev/devtools/customer/index.tsx",
      "parent": "/_auth/_dev"
    },
    "/_auth/_dev/devtools/role-o-matic/": {
      "filePath": "_auth/_dev/devtools/role-o-matic/index.tsx",
      "parent": "/_auth/_dev"
    },
    "/_auth/ipaws/certificates/$certId/": {
      "filePath": "_auth/ipaws/certificates/$certId/index.tsx",
      "parent": "/_auth/ipaws/certificates"
    }
  }
}
ROUTE_MANIFEST_END */
